<template>
	<div class="app-container">
		<PaymentInformation v-if="hasCard && !loading" />
		<CardNew v-if="!hasCard && !loading" :user="getUser()" />
		<Spinner v-if="loading" />
		<ErrorDialog ref="errDialog" />
	</div>
</template>

<script>
import CardNew from './CardNew';
import PaymentInformation from './PaymentInformation';
import CardService from '../../services/card';
import ErrorDialog from '../shared/ErrorDialog';
import Spinner from '../shared/Spinner';
import ConsoleService from '../../services/console';

export default {
	name: 'Payment',
	components: {
		CardNew,
		PaymentInformation,
		ErrorDialog,
		Spinner,
	},
	data() {
		return {
			hasCard: false,
			loading: false,
		};
	},
	mounted() {
		this.checkIfCard();
	},
	methods: {
		checkIfCard() {
			this.loading = true;
			CardService.instance()
				.checkIfCard()
				.then((result) => {
					this.loading = false;
					this.hasCard = result.data;
				})
				.catch((err) => {
					this.loading = false;
					this.$refs.errDialog.show(err);
				});
		},
		getUser() {
			return ConsoleService.instance().currentUser();
		},
	},
};
</script>

<style scoped>
.payment {
	padding-top: 5rem;
	height: 100%;
	overflow: auto;
	width: 100%;
	display: block;
}
.payment-header {
	max-width: 500px;
	width: 100%;
	margin: auto;
	text-align: center;
	font-size: 2rem;
	margin-bottom: 3rem;
}
.payment-header::after {
	display: none;
}
.payment-header::before {
	display: none;
}
</style>
